export const FETCH_PLASTIC_CARD_LOADING = 'FETCH_PLASTIC_CARD_LOADING';
export const FETCH_PLASTIC_CARD_FAILURE = 'FETCH_PLASTIC_CARD_FAILURE';
export const FETCH_PLASTIC_CARD_SUCCESS = 'FETCH_PLASTIC_CARD_SUCCESS';
